module.exports = __webpack_public_path__ + "static/img/logo.eaa079d8.png";